import { TRY, NUM, fmtDateTime } from "@/lib/format";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { CloudOff, RefreshCw, Undo2, Trash2, AlertTriangle } from "lucide-react";

// Çevrimdışıyken kuyruğa alınan satışlar: bağlantı gelince otomatik gönderilir; gönderilemeyen (hata) sepete geri yüklenebilir
export function PendingSalesBar({ pending, onRetry, onRestore, onRemove }) {
  if (!pending?.length) return null;
  return (
    <div className="space-y-2" data-testid="pending-sales-bar">
      {pending.map((p) => {
        const err = p.status === "error";
        return (
          <div key={p.key} className={cn("flex flex-col sm:flex-row sm:items-center gap-2 rounded-2xl border px-4 py-3", err ? "border-red-300 bg-red-50/70" : "border-amber-300 bg-amber-50/70")} data-testid={`pending-sale-${p.key}`}>
            <div className={cn("grid h-9 w-9 place-items-center rounded-xl shrink-0", err ? "bg-red-100 text-red-700" : "bg-amber-100 text-amber-700")}>{err ? <AlertTriangle className="h-4 w-4" /> : <CloudOff className="h-4 w-4" />}</div>
            <div className="min-w-0 flex-1">
              <div className={cn("text-sm font-bold", err ? "text-red-800" : "text-amber-900")}>{err ? "Bekleyen satış gönderilemedi" : "Bekleyen satış — bağlantı gelince otomatik gönderilecek"}</div>
              <div className="text-xs text-muted-foreground tnum truncate">{fmtDateTime(new Date(p.at).toISOString())} · {p.items?.length || 0} kalem · <b className="text-foreground">{TRY(p.grand)}</b>{p.title ? ` · ${p.title}` : ""}{err && p.error ? <span className="text-red-700"> · {p.error}</span> : ""}</div>
            </div>
            <div className="flex items-center gap-1.5 shrink-0">
              {!err && <Button size="sm" variant="outline" className="h-8 rounded-xl" onClick={onRetry} data-testid={`pending-retry-${p.key}`}><RefreshCw className="h-3.5 w-3.5 mr-1" />Şimdi Dene</Button>}
              <Button size="sm" variant="outline" className="h-8 rounded-xl" onClick={() => onRestore(p.key)} data-testid={`pending-restore-${p.key}`}><Undo2 className="h-3.5 w-3.5 mr-1" />Sepete Geri Yükle</Button>
              <Button size="sm" variant="ghost" className="h-8 w-8 px-0 rounded-xl text-destructive hover:text-destructive hover:bg-red-100" onClick={() => onRemove(p.key)} title="Kuyruktan sil" data-testid={`pending-remove-${p.key}`}><Trash2 className="h-3.5 w-3.5" /></Button>
            </div>
            <span className="sr-only">{NUM(p.items?.length || 0)}</span>
          </div>
        );
      })}
    </div>
  );
}
